import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { IconButton } from '@mui/material';
import { IconClose } from '../../../assets/icons';
import './index.scss';

type DialogProps = {
  show?: boolean;
  setShow: (show: boolean) => void;
  children?: ReactNode;
  title?: string;
  isBottomPosition?: boolean;
  closeBtn?: boolean;
  className?: string;
  backdropCloseDisabled?: boolean;
  titleIcon?: React.ReactNode;
  backgroundBlur?: boolean;
};

export const Dialog: React.FC<DialogProps> = ({
  show,
  setShow,
  children,
  isBottomPosition,
  className = false,
  title,
  closeBtn,
  titleIcon,
  backdropCloseDisabled = false,
  backgroundBlur,
}) => {
  const dialogRootElement = document.querySelector('#modal-root');

  const handleClose = () => {
    if (!backdropCloseDisabled) setShow(false);
  };

  if (!show) return null;

  return (
    dialogRootElement &&
    ReactDOM.createPortal(
      <div
        className={classNames('dialog', {
          'dialog--active': show,
          'dialog--bottom': isBottomPosition,
          [className as string]: className,
        })}
      >
        <div className={classNames('dialog__backdrop', { 'background-blur': backgroundBlur })} onClick={handleClose} />
        <div className="dialog__content">
          {closeBtn && (
            <div className="dialog__closeBtn">
              <IconButton onClick={() => setShow(false)}>
                <IconClose />
              </IconButton>
            </div>
          )}
          {title && (
            <div className="dialog__title">
              {title} {titleIcon ? titleIcon : null}
            </div>
          )}
          {children}
        </div>
      </div>,
      dialogRootElement,
    )
  );
};
